import { Box, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import {
  footfallGraph
  // footfallEmployeeGraph
} from 'api/sentinelAPI';
// import Bubbledxaxis from './Bubbledx-axis';
// import {footfallGraph} from "api/sentinelAPI";
// const footfalldata=footfallGraph();
import { useSelector } from 'react-redux';

const Areachart = () => {
  const [category, setCategory] = useState([]);
  const [custCount, setCustCount] = useState([]);
  const [empCount, setEmpCount] = useState([]);
  const [loading, setLoading] = useState(false);
  const date = useSelector((state) => state.customization.currentDate);
  const zone = useSelector((state) => state.customization.selectedZone);

  const selectedTime = useSelector((state) => state.customization.selectedTime);
  const startTime = new Date(selectedTime.start_time);
  const endTime = new Date(selectedTime.end_time);

  const formattedStartTimeIST = startTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }).split(',')[1];
  const formattedEndTimeIST = endTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }).split(',')[1];

  const [isMounted, setIsMounted] = useState(false);

  async function getData(commonBody, signal) {
    try {
      setLoading(true);
      const data = await footfallGraph(commonBody, { signal }); // Pass the signal to your API call
      if (!signal.aborted) {
        // Only proceed if the fetch was not aborted
        if (data && data.length > 0) {
          // console.log('Footfall graph data', data);
          const catagorydata = data.map((d) => d.date);
          const custdata = data.map((d) => d.customer_count);
          const empdata = data.map((d) => d.employee_count);
          setCategory(catagorydata);
          setCustCount(custdata);
          setEmpCount(empdata);
        } else if (data && data.length === 0) {
          setCategory([]);
          setCustCount([]);
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        // Only handle the error if the fetch was not aborted
        console.log(error);
      }
    } finally {
      if (!signal.aborted) {
        // Only set loading to false if the fetch was not aborted
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    if (isMounted) {
      const commonBody = {
        start_time: formattedStartTimeIST,
        end_time: formattedEndTimeIST,
        start_date: date,
        zone: zone,
        storeId: '65c5e26a0b5be5dc7af327dc'
      };

      getData(commonBody, signal);
      // getEmployeeGraphData(commonBody, signal);
    }

    return () => {
      abortController.abort(); // Abort the fetch when the component unmounts or date changes
    };
    // eslint-disable-next-line
  }, [isMounted, date, zone, formattedStartTimeIST, formattedEndTimeIST]);

  //graph options start

  const state = {
    series: [
      {
        name: 'Customers',
        data: custCount
        // [4, 7, 4, 20, 18, 80, 100,40, 60,30, 20, 33, 15,9, 4 ]
      },
      {
        name: 'Employees',
        data: empCount
        // [2, 4, 3, 10, 9, 62, 51,40, 20 ,18, 15,10,6,4,2]
      }
      //     , {
      //       name: 'Male',
      //       data: [3, 6, 2, 12, 10, 52, 41,80,40, 85, 56,18,20,9,4]
      //     },
      // {

      //         name: 'Female',
      //         data: [2, 4, 3, 10, 9, 62, 51,40, 20 ,18, 15,10,6,4,2]

      // }
    ],
    options: {
      chart: {
        type: 'area',
        toolbar: {
          show: false
        },
        animations: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      legend: {
        show: true, // Ensure legend is visible
        position: 'top', // Set position to 'top'
        horizontalAlign: 'center',
        customLegendItems: ['Customers', 'Employees'],
        showForSingleSeries: true
        // ... other legend options
      },
      xaxis: {
        type: 'datetime',
        tickAmount: 15,
        categories: category,
        // ["2018-09-19T15:30:00.000Z", "2018-09-19T16:00:00.000Z", "2018-09-19T16:30:00.000Z", "2018-09-19T17:00:00.000Z", "2018-09-19T17:30:00.000Z", "2018-09-19T18:00:00.000Z", "2018-09-19T18:30:00.000Z",  "2018-09-19T19:00:00.000Z",  "2018-09-19T19:30:00.000Z",  "2018-09-19T20:00:00.000Z",  "2018-09-19T20:30:00.000Z",  "2018-09-19T21:00:00.000Z",  "2018-09-19T21:30:00.000Z",  "2018-09-19T22:00:00.000Z",  "2018-09-19T22:30:00.000Z"],
        labels: {
          show: true // Display all labels on the X-axis
          // rotate: -45, // Rotate labels to 0 degrees
          // showDuplicates: true,
        }
      },
      tooltip: {
        // enabled:false,
        x: {
          format: 'dd/MM/yy HH:mm'
        }
      },
      // toolbar: {
      //   show: false, // Set to false to hide the toolbar/menu items above the chart
      // },
      yaxis: {
        type: 'Number'
        // categories:['0','5','10','15','20','25','30','35','40','45','50','55','60','65','70','75','80','85','90','95','100']
      },
      colors: ['#37c6fa', '#ff6c00']
      // , '#9887fa', '#9C27B0'],
    }
  };

  //graph options end

  // console.log(footfalldata);
  return (
    <>
      {/* {custCount.length > 0 ? (
        <Box sx={{ overflow: 'hidden' }}>
          <ReactApexChart options={state.options} series={state.series} type="area" width="100%" height={400} />
        </Box>
      ) : (
        
      )} */}
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="300px">
          <CircularProgress />
        </Box>
      ) : custCount.length > 0 ? (
        <Box sx={{ overflow: 'hidden' }}>
          <ReactApexChart options={state.options} series={state.series} type="area" width="100%" height={400} />
        </Box>
      ) : (
        <div className="w-full h-full flex justify-center place-items-center text-xl">No data</div>
      )}
    </>
  );
};

export default Areachart;
